export const SURVEY_GIZMO_LABEL = "Survey Gizmo";
export const SURVEY_GIZMO_VALUE = "surveygizmo";
export const REDCAP_LABEL = "REDCap";
export const REDCAP_VALUE = "redcap";
